export const apiConfig = {
  base: process.env.NEXT_PRIVATE_BASE_SERVICE_URL,
  auth: process.env.NEXT_PRIVATE_AUTH_SERVICE_URL,
  user: process.env.NEXT_PRIVATE_USER_SERVICE_URL,
  categories: process.env.NEXT_PRIVATE_CATEGORIES_SERVICE_URL,
  business_logic: process.env.NEXT_PRIVATE_BUSINESS_LOGIC_SERVICE_URL,
  portal_service: process.env.NEXT_PRIVATE_PORTAL_SERVICE_URL,
  system_service: process.env.NEXT_PRIVATE_SYSTEM_SERVICE_URL,
  notification: process.env.NEXT_PRIVATE_NOTIFICATION_SERVICE_URL,
};
